import { useItemBundle } from '@hooks';
import { useEffect, useMemo } from 'react';
import ProductDetails from './ProductDetails';

const ProductWithBundle = ({ shopItemId, inlineBundleData, ...props }) => {
  const [bundleInfo, onChoiceChange, onCustomize] = useItemBundle({
    bundleData: inlineBundleData,
    forcedSelectedIds: { 0: shopItemId },
  });
  const { designId: designIdQueryParam, customizing: customizingQueryParam } = Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  );

  useEffect(() => {
    if (!!customizingQueryParam && !!designIdQueryParam) {
      onCustomize(parseInt(customizingQueryParam));
    }
  }, [customizingQueryParam, designIdQueryParam]);

  return <ProductDetails {...(props as any)} bundleInfo={bundleInfo} onChoiceChange={onChoiceChange} />;
};

export default ProductWithBundle;
